import { render, staticRenderFns } from "./NonTransferableLogsTab.vue?vue&type=template&id=f7a64c42&"
import script from "./NonTransferableLogsTab.vue?vue&type=script&lang=ts&"
export * from "./NonTransferableLogsTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports